import React from 'react';
import { withRouter } from 'react-router';

import validatePassword from 'bl/validation/validatePassword.bl';
import { withRcmNewPasswordRequired } from 'utils/cognito.util';
import logger from 'utils/logger.util';

import PopupModalContainer from 'common/PopupModal';
import PasswordInputField from 'onboarding/common/PasswordInputField';
import Button from 'settings/page-elements/Button';
import HeaderContainer from 'user/common/Header';

const L = logger('NewPasswordRequiredForm');

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordConfirm: '',
      error: '',
      passwordHasError: true,
      submitting: false,
    };
  }

  onSubmit = () => {
    if (this.state.password === '') {
      this.setState({ error: 'No password entered' });
    } else if (this.state.password !== this.state.passwordConfirm) {
      this.setState({ error: 'Passwords do not match' });
    } else {
      this.setState({ error: '' });
      this.setState({ submitting: true }, () => {
        if (this.props.onSubmit) {
          this.props
            .onSubmit(this.state.password)
            .then(() => {
              window.location.replace(`${window.location.origin}`);
            })
            .catch((e) => {
              this.setState({ submitting: false });
              this.setState({ error: 'There was an error trying to set the new password.' });
              L.warn('onSubmit() > catch()', e);
            });
        }
      });
    }
  };

  onPasswordChange = (value, keyToUse) => {
    const newState = {};
    newState[keyToUse] = value;
    this.setState(newState);
  };

  validatePassword = (value) => {
    if (validatePassword({ value })) {
      this.setState({ passwordHasError: false });
      return '';
    }
    this.setState({ passwordHasError: true });
    return 'Password needs to be at least 8 characters in length and contain an uppercase character and a number.';
  };

  validateConfirmPassword = (value) => {
    if (value === this.state.password) {
      this.setState({ passwordHasError: false });
      return '';
    }
    this.setState({ passwordHasError: true });
    // eslint-disable-next-line  max-len
    return 'The passwords does not match.';
  };

  hideError = () => {
    this.setState({ error: '' });
  };

  render() {
    return (
      <div data-bem="ResetPassword" className="screen-wrap">
        <div data-bem="ResetPassword__header" className="header-bg" />
        <div data-bem="ResetPassword__contents" className="content-wrap">
          <HeaderContainer title="" description="New password required" />
          {this.state.error && (
            <PopupModalContainer
              popupTitle="Error"
              popupMessage={this.state.error}
              buttonText="Okay"
              buttonCallback={this.hideError}
            />
          )}

          <div className="content login auto-height">
            <PasswordInputField
              data={{
                id: 'PasswordInput',
                label: 'Create a Password',
                type: 'password',
                placeholder: '●●●●●●●●',
                inputValue: '',
                inputMode: 'text',
              }}
              onChangeHandler={(value) => {
                this.onPasswordChange(value, 'password');
              }}
              validateBlur={this.validatePassword}
              allowAutocomplete={false}
            />
            <PasswordInputField
              data={{
                id: 'PasswordInput2',
                label: 'Confirm the Password',
                type: 'password',
                placeholder: '●●●●●●●●',
                inputValue: '',
                inputMode: 'text',
              }}
              onChangeHandler={(value) => {
                this.onPasswordChange(value, 'passwordConfirm');
              }}
              validateBlur={this.validateConfirmPassword}
              allowAutocomplete={false}
            />
          </div>
          <footer className="footer">
            <div className="footer-content-buttons ">
              <div className="force-password">
                <Button
                  className="btn btn-primary"
                  disabled={
                    this.state.passwordHasError ||
                    this.state.password !== this.state.passwordConfirm ||
                    this.state.submitting
                  }
                  onClickButton={this.onSubmit}
                  buttonName=""
                />
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                <span className="ic-sml ic-arrow-forward-white" onClick={this.onSubmit} />
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}

const ResetPasswordHoC = withRcmNewPasswordRequired(withRouter(ResetPassword));

// this extra export is needed for tests that provide their own mock for connect()
export { ResetPassword as ResetPasswordForTest };
export default ResetPasswordHoC;
